import React from "react";
import useCustomizableContext from "../../useCustomizableContext";
import { env } from "~/common/Environment";

interface Props {
  isLoadingCart: boolean;
  isTrs: boolean;
  setOpenModal: () => void;
}

const buildTrsProductLink = (itemNumberId: number) => {
  const { current, isProd } = env;
  const subdomain = isProd ? "" : `${current}.`;

  return `https://www.${subdomain}therestaurantstore.com/items/${itemNumberId}`;
};

const CustomizablePageHeader = ({
  isLoadingCart,
  isTrs,
  setOpenModal,
}: Props) => {
  const {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    productData,
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    variationData,
    // thunks
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    changeProduct,
  } = useCustomizableContext();

  const trsProductLink = buildTrsProductLink(productData.itemNumberId);

  return (
    <div id="customizable-header" className="customize__header">
      <div className="container flex customize__split-container customize__split-container--vertical box-content">
        <div className="customize__header-text customize__split">
          <h1 className="customize__header-title">{productData.title}</h1>
          <div className="customize__design-considerations-wrapper">
            <button
              type="button"
              className="btn btn-small btn-white"
              onClick={setOpenModal}
              data-toggle="modal"
            >
              <i className="icon-info-circled" /> Design Considerations
            </button>
            <span className="customize__header-item-num px-1">
              Item: #
              <a href={isTrs ? trsProductLink : productData.productLink}>
                {productData.itemNumber}
              </a>
            </span>
          </div>
        </div>
        {variationData.variationItems.length > 1 && (
          <div className="customize__header-options customize__split flex">
            <span className="customize__header-label">Product Options:</span>
            <form className="form customize__header-form">
              <div className="form__group form__group--collapse">
                <div className="form__control-container">
                  <select
                    className="form__control"
                    disabled={isLoadingCart}
                    onChange={(e) => changeProduct(Number(e.target.value))}
                  >
                    {
                      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                      // @ts-ignore
                      variationData.variationItems.map((v) => (
                        <option
                          selected={v.itemNumberId === productData.itemNumberId}
                          value={v.itemNumberId}
                        >
                          {v.variationValue}
                        </option>
                      ))
                    }
                  </select>
                  <label className="form__label">
                    {variationData.variationDescription}
                  </label>
                  <span className="icon-down-micro form__control-icon form__control-icon--lg" />
                </div>
              </div>
            </form>
          </div>
        )}
      </div>
    </div>
  );
};

export default CustomizablePageHeader;
